const theme = (process.env.THEME && process.env.THEME.toLowerCase()) || 'next'
export default theme
